module.exports = __webpack_public_path__ + "b1c81e2daa2338e9d9b3e290a7662ba1.MP3";